import type { FC, ReactNode } from 'react'

import { useTheme } from 'next-themes'
import { Moon, Sun } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'

// One click switches between light and dark. The first visit follows the device setting.
// The icon is driven by the `dark` class on <html>, so it is right on the very first paint.
export const ThemeToggle: FC<{ className?: string }> = ({ className }): ReactNode => {
    const { setTheme } = useTheme()

    const toggle = (): void => {
        const isDark = document.documentElement.classList.contains('dark')

        setTheme(isDark ? 'light' : 'dark')
    }

    return (
        <button
            type='button'
            onClick={toggle}
            className={buttonVariants({ variant: 'outline', size: 'icon', className })}
            aria-label='Ganti tema gelap/terang'
            title='Ganti tema gelap/terang'
        >
            <Moon className='size-[18px] dark:hidden' aria-hidden='true' />
            <Sun className='hidden size-[18px] dark:block' aria-hidden='true' />
        </button>
    )
}
